import { createSystem, defaultConfig, defineConfig, defineRecipe, defineTextStyles } from "@chakra-ui/react"

export const buttonRecipe = defineRecipe({
  base: {
    fontWeight: 'bold',
    borderRadius: 'md',
  },
  variants: {
    variant: {
      solid: {
        bg: 'brand.secondary',
        color: 'white',
        _hover: {
          bg: 'brand.dark',
        },
      },
      outline: {
        bg: 'transparent',
        border: '2px solid',
        borderColor: 'brand.secondary',
        color: 'brand.secondary',
        _hover: {
          bg: 'brand.secondary',
          color: 'white',
        },
      },
    },
    size: {
      sm: {
        h: '8',
        minW: '8',
        fontSize: 'sm',
        px: '3',
      },
      md: {
        h: '10',
        minW: '10',
        fontSize: 'md',
        px: '4',
      },
      lg: {
        h: '12',
        minW: '12',
        fontSize: 'lg',
        px: '6',
      },
    },
  },
  defaultVariants: {
    variant: 'solid',
    size: 'md',
  },
})

const globalCss = defineConfig({
  globalCss: {
    "html, body": {
      bg: 'white',
      color: 'gray.800',
    },
  },
})

export const textStyles = defineTextStyles({
  display: {
    value: {
      fontSize: 'clamp(1.5rem, 4vw, 3.75rem)', // 24px to 60px
      fontWeight: 'bold',
      lineHeight: '1.2',
    },
  },
  heading: {
    value: {
      fontSize: 'clamp(1.125rem, 3vw, 2.25rem)', // 18px to 36px
      fontWeight: 'bold',
      lineHeight: '1.3',
    },
  },
  subheading: {
    value: {
      fontSize: 'clamp(1rem, 2.5vw, 1.5rem)', // 16px to 24px
      fontWeight: 'semibold',
      lineHeight: '1.4',
    },
  },
  body: {
    value: {
      fontSize: 'clamp(0.875rem, 2vw, 1.125rem)', // 14px to 18px
      lineHeight: '1.6',
    },
  },
})

// Color ref, colors defined so you can see them previewed in IDE
// #fffbeb
// #fff3c6
// #ffe788
// #fed44b
// #febd17
// #f89e08
// #dc7603
// #b65307
// #94400c
// #79350e
// #461a02
const config = defineConfig({
  ...globalCss,
  theme: {
    tokens: {
      colors: {
        brand : {
          primary: { value: '#fed44b' }, // amber.300
          secondary: { value: '#f89e08' }, // amber.500
          accent: { value: '#ffe788' }, // amber.200
          dark: { value: '#b65307' }, // amber.700
          light: { value: '#fffbeb' }, // amber.50
          highlight: { value: '#dc7603' }, // amber.600
          subtle: { value: '#fff3c6' }, // amber.100
        },
        amber: {
          50: { value: '#fffbeb' },
          100: { value: '#fff3c6' },
          200: { value: '#ffe788' },
          300: { value: '#fed44b' },
          400: { value: '#febd17' },
          500: { value: '#f89e08' },
          600: { value: '#dc7603' },
          700: { value: '#b65307' },
          800: { value: '#94400c' },
          900: { value: '#79350e' },
          950: { value: '#461a02' },
        },
      },
      fonts: {
        heading: { value: '"Poppins", sans-serif' },
        body: { value: '"Inter", sans-serif' },
      }
    },
    semanticTokens: {
      colors: {
        brand: {
          solid: { value: "{colors.brand.500}" },
          contrast: { value: "{colors.brand.100}" },
          fg: { value: "{colors.brand.700}" },
          muted: { value: "{colors.brand.100}" },
          subtle: { value: "{colors.brand.200}" },
          emphasized: { value: "{colors.brand.300}" },
          focusRing: { value: "{colors.brand.500}" },
        },
      },
    },
    textStyles,
    recipes: {
      button: buttonRecipe,
    },
  },
})


export const system = createSystem(defaultConfig, config)


